// extracted by css-extract-rspack-plugin
export default {"card-wrapper":"AuctionBudgetCard-module__card-wrapper--xquJ5","cardWrapper":"AuctionBudgetCard-module__card-wrapper--xquJ5"};